<eds-app-shell [hasSideBar]="authService.currentUser()?.isActive ?? false">
  <!-- ng-content section for breadcrumbs -->
  <ng-container appShellMainHeaderBreadcrumbs>
    <eds-breadcrumbs
      [breadcrumbs]="breadCrumbs()"
      data-test="breadcrumbs"
      [lastBreadcrumbClickable]="false"
    />
  </ng-container>

  <!-- ng-content section for main header logo -->
  <ng-container appShellMainHeaderLogo>
    <tlm-logo />
  </ng-container>

  <!-- ng-content section for header actions -->
  @if (authService.currentUser()?.isActive) {
    <ng-container appShellMainHeaderActions>
      <div class="flex items-center justify-end gap-4">
        <button
          edsUserMenuTrigger
          [givenName]="authService.currentUser()?.firstName"
          [familyName]="authService.currentUser()?.lastName"
          [cdkMenuTriggerFor]="menu"
        >
          {{ authService.currentUser()?.firstName }} {{ authService.currentUser()?.lastName }}
        </button>
        <ng-template #menu>
          <eds-user-menu>
            <a
              eds-menu-item
              [edsMenuTriggerFor]="languageMenu"
              iconName="translate"
              data-test="language-menu-trigger"
            >
              {{ 'eds.userMenu.language' | translate }}
            </a>

            <ng-template #languageMenu>
              <eds-user-menu-language-picker-menu [locales]="locales" />
            </ng-template>

            <a
              eds-menu-item
              [iconName]="themeService.isDarkTheme ? themeIcon.Dark : themeIcon.Light"
              [cdkMenuTriggerFor]="themeMenu"
              data-test="eds-theme-picker-menu-trigger"
            >
              {{ 'eds.userMenu.themePicker.label' | translate }}
            </a>
            <ng-template #themeMenu>
              <eds-user-menu-theme-picker-menu />
            </ng-template>
            <button eds-menu-item iconName="logout" (click)="authService.logout()">
              {{ 'common.buttons.logout' | translate }}
            </button>
          </eds-user-menu>
        </ng-template>
      </div>
    </ng-container>
  }

  <!-- ng-content section for App-Bar -->
  <ng-container appShellAppBar>
    <eds-app-bar>
      <eds-context-switcher
        icon="person"
        label=""
        [value]="
          authService.currentUser()?.firstName + ' ' + authService.currentUser()?.lastName + ' -'
        "
      >
        <button edsIconButton="tertiary" edsIconButtonSize="tiny">
          {{ authService.currentUser()?.roleName }}
        </button>
      </eds-context-switcher>
    </eds-app-bar>
  </ng-container>

  <!-- ng-content section for the left sidebar -->
  @if (authService.currentUser()?.isActive === true) {
    <ng-container appShellSideBarContent>
      <eds-app-menu [items]="appMenuItems()" pageHeader="App Menu" />
    </ng-container>
  }

  <!-- ng-content section for the main page content -->
  <!-- check out the "page ribbon" component/directive for more detailed use cases -->
  <div appShellPageContent class="px-8 pt-2 pb-6 md:pt-6">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
</eds-app-shell>
